import { AddressDto } from "./address.dto";

export class ContactDto {
    id: number;
    phone: string;
    email: string;
    address: AddressDto;

    constructor(phone?: string, email?: string, address?: AddressDto) {
        this.phone = phone;
        this.email = email;
        this.address = address;
    }
}
